module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-wrp"
  }, [_c('img', {
    staticClass: "login-icon c-p",
    attrs: {
      "src": require("../assets/cosmolove-logo-3.png")
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-content clearfix"
  }, [_c('img', {
    staticClass: "login-banner pull-left",
    attrs: {
      "src": require("../assets/login_qrcode.png")
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "login-form pull-right",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_c('h4', {
    staticClass: "login-form-header"
  }, [_vm._v("登录")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "f-w login-f-control m-b",
    attrs: {
      "placeholder": "请输入手机号",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "f-w login-f-control",
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "c-b-login c-b-primary f-w m-t-md",
    attrs: {
      "disabled": _vm.loginDisabled()
    }
  }, [_vm._v("登录")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-small text-gray",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("\n          登录即表示同意\n          "), _c('a', {
    staticClass: "link-text",
    attrs: {
      "target": "_blank",
      "href": "#/user/policy"
    }
  }, [_vm._v("《时尚新娘用户协议》")]), _vm._v(" "), _c('a', {
    staticClass: "link-text register",
    attrs: {
      "href": "#/register"
    }
  }, [_vm._v("立即注册>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forget-pw"
  }, [_c('a', {
    attrs: {
      "href": "#/forgetpass"
    }
  }, [_vm._v("忘记密码>")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6ee56b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 613
// module chunks = 1